// import { Link } from "react-router-dom"

import EntityPerformanceChartModal from '../../../../components/EntityPerformanceChartModal/EntityPerformanceChartModal'
import ProfitTrendModal from '../modals/ProfitTrendModal'
import {useState, useContext} from 'react'
import {PurchaserByBrandReportContext} from '../../context'
import {MIN_DATE_RANGE} from '../../utils'

const PurchaserByBrandReportRow = ({row}: any) => {
  const [showChartModal, setShowChartModal] = useState(false)
  const [showProfitTrendModal, setShowProfitTrendModal] = useState(false)

  const {
    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
    // Profit Trend Modal Data
    profitTrendChartData,
    profitTrendKpiData,
    profitTrendWeeklyBreakdownData,
    isProfitTrendDataLoading,
    onProfitTrendIdChange,
  } = useContext(PurchaserByBrandReportContext)

  return (
    <>
      <tr>
        <td>{row.purchaserName}</td>
        <td>
          {/* <Link
          to={{
            pathname: '/analytics/profitability/profitability-report',
            search: `?view=order-report&purchaser_name=${row.purchaserName}`,
          }}
          target='_blank'
          className='text-dark text-decoration-underline'
        > */}
          {row.orderCount}
          {/* </Link> */}
        </td>
        <td>{row.totalCost}</td>
        <td>{row.totalSale}</td>
        <td>{row.totalProfit}</td>
        <td>
          <span
            onClick={() => setShowProfitTrendModal(true)}
            className='text-hover-primary cursor-pointer text-decoration-underline'
            style={{cursor: 'pointer'}}
          >
            {row.profitPercentage}
          </span>
        </td>
        <td>{row.contributedProfitPercentage}</td>
        <td>
          <div className='d-flex justify-content-end'>
            <span
              onClick={() => setShowChartModal(true)}
              className='w-30px h-30px d-flex justify-content-center align-items-center text-primary cursor-pointer'
            >
              <i className='fas fa-chart-line text-primary'></i>
            </span>
          </div>
        </td>
      </tr>
      {showChartModal && (
        <EntityPerformanceChartModal
          onClose={() => setShowChartModal(false)}
          entityId={row.purchaserName}
          entityName={`Profitability Report - ${row.purchaserName}`}
          onEntityPerformanceChartIdChange={onEntityPerformanceChartIdChange}
          onEntityPerformanceChartViewChange={onEntityPerformanceChartViewChange}
          onEntityPerformanceChartDateRangeChange={onEntityPerformanceChartDateRangeChange}
          entityPerformanceChartFilters={entityPerformanceChartFilters}
          isEntityPerformanceChartDataLoading={isEntityPerformanceChartDataLoading}
          entityPerformanceChartData={entityPerformanceChartData}
          startDate={MIN_DATE_RANGE}
        />
      )}

      {showProfitTrendModal && (
        <ProfitTrendModal
          onClose={() => setShowProfitTrendModal(false)}
          entityId={row.purchaserName}
          entityName={row.purchaserName}
          onProfitTrendIdChange={onProfitTrendIdChange}
          isProfitTrendDataLoading={isProfitTrendDataLoading}
          profitTrendChartData={profitTrendChartData}
          kpiData={profitTrendKpiData}
          weeklyBreakdownData={profitTrendWeeklyBreakdownData}
        />
      )}
    </>
  )
}

export default PurchaserByBrandReportRow
